module.exports = __webpack_public_path__ + "img/Q4.6f404a0f.jpg";